import { USER_STATUS } from 'Constants/users';

const getUserFromProp = props => {
    const { router: { params = {}} = {}} = props || {};

    return (params && params.userId) ? params.userId : '';
};

const getReviewIdsFromProp = props => {
    const { location: { query = {}} = {}} = props || {};
    const buyerId = (query && query.buyer_id) ? query.buyer_id : '';
    const sellerId = (query && query.seller_id) ? query.seller_id : '';
    const adId = (query && query.ad_id) ? query.ad_id : '';

    return { buyerId, sellerId, adId };
};

const getLoginMethod = userName => {
    if (userName.search('@') > 0) {
        return 'email';
    }

    return 'phone';
};

const handleCopyToClipBoard = (text, setToastMessage, setShowToast, message, toastTime) => {
    // eslint-disable-next-line no-undef
    navigator.clipboard.writeText(text)
        .then(() => {
            setToastMessage(message);
            setShowToast(true);
            setTimeout(() => setShowToast(false), toastTime);
        })
        .catch(() => {
            setShowToast(true);
            setTimeout(() => setShowToast(false), toastTime);
        });
};

const isInActiveUser = (user = {}) => {
    return user?.status === USER_STATUS.INACTIVE;
};

const getUserInfoByCategory = (user = {}, categoryId) => {
    if (!user?.dealer || !Array.isArray(user?.dealer?.categories)) {
        return {};
    }

    const category = user.dealer.categories.find(cat => Number(cat.id) === Number(categoryId));

    return category || {};
};

export {
    getUserFromProp,
    getLoginMethod,
    getReviewIdsFromProp,
    handleCopyToClipBoard,
    isInActiveUser,
    getUserInfoByCategory
};
